import { defineMessage } from 'services/localization';

export const messages = {
    greenText: defineMessage('you_have_paid_this_contact_before'),
    yellowText: defineMessage('first_payment'),
    redText: defineMessage('payment_details_have_changed'),
    grayText: defineMessage('not_checked'),
};
